import { ReviewProduct } from "@interfaces/dto/review.dto";
import Ratings from "../info/Ratings";
import ReviewLikeButton from "../../product-review/ReviewLikeButton";
import Pagination from "@components/atoms/Pagination";
import { REVIEW_PAGE_SIZE } from "@const/products.const";
import ImageModal from "@components/features/image-modal/ImageModal";
import { useState } from "react";
import { useWindowDimensions } from "@utils/common.util";
import encryptName from "@api/products/reviews";
import SkeletonProductCart from "@components/atoms/skeleton/ui-product-cart";

interface Props {
  dataReview: ReviewProduct[] | undefined;
  isLoadingReviewProducts: boolean;
  reviewCurrentPage: number;
  setReviewCurrentPage: (page: number) => void;
  totalReviewsFilter: number;
}

const ProductReviewItem = ({
  dataReview,
  isLoadingReviewProducts,
  reviewCurrentPage,
  setReviewCurrentPage,
  totalReviewsFilter,
}: Props) => {
  // console.log("Data in component:", dataReview);

  const [selectedProductImg, setSelectedProductImg] = useState<null | string>(
    null
  );
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  let sizeScreen = useWindowDimensions().width;

  const showImageModal = () => {
    if (selectedProductImg === null) {
      return;
    }
    return (
      <>
        <ImageModal
          screenSize={sizeScreen}
          isShow={show}
          handleClose={handleClose}
          selectedImg={selectedProductImg}
        />
      </>
    );
  };

  return (
    <>
      {showImageModal()}
      {isLoadingReviewProducts ? (
        <SkeletonProductCart />
      ) : (
        <>
          {dataReview &&
            dataReview.map((review) => {
              return (
                <li key={review.review_id}>
                  <div className="d-inline-flex comment-name">
                    <img
                      className="reviewer-img"
                      src={"/assets/images/icon-account-circle-red.png"}
                      alt="reviewer-profile"
                    />
                    <div className="mx-2">
                      <h5>{encryptName(review.nickname)}</h5>
                      <Ratings starCount={review.ratings} />
                    </div>
                  </div>
                  <div className="d-block">
                    <p>{review.detail}</p>
                    {review.images &&
                      review.images.slice(0, 4).map((img, index) => (
                        <img
                          key={index}
                          className="review-img"
                          src={img.image_path}
                          alt={`review-img-${index}`}
                          onClick={() => {
                            setSelectedProductImg(img.image_path);
                            setShow(true);
                          }}
                        />
                      ))}
                    {/* {review.images && review.images.length > 3 && (
                <div
                  className="d-inline-block review-img review-img-more"
                  style={{
                    backgroundImage: `url(${review.images[3].image_path})`,
                  }}
                >
                  <div className="review-img review-img-transbox">
                    <span className="review-img">
                      +{review.images.length - 3}
                    </span>
                  </div>
                </div>
              )} */}
                    <div className="row mt-2">
                      <div className="col-12 col-lg-8 col-md-6 m-auto">
                        <h6 className="my-2">
                          รีวิวเมื่อ: {review.review_created_at}
                        </h6>
                      </div>
                      <div className="col-12 col-lg-4 col-md-6 d-flex justify-content-between">
                        {/* <h6 className="text-secondary my-auto">
                    รีวิวนี้ช่วยเพื่อนๆมั้ย?
                  </h6>
                  <ReviewLikeButton /> */}
                      </div>
                    </div>
                  </div>
                </li>
              );
            })}

          {dataReview && dataReview.length > 0 ? (
            <Pagination
              currentPage={reviewCurrentPage}
              setCurrentPage={setReviewCurrentPage}
              totalItem={totalReviewsFilter}
              pageSize={REVIEW_PAGE_SIZE}
            />
          ) : (
            <p className="text-secondary text-center">ไม่มีรีวิวสินค้านี้</p>
          )}
        </>
      )}
    </>
  );
};

export default ProductReviewItem;
